const targetCam = n => n.get('type') === 'Camera';
const targetRen = n => n.get('type') === 'Renderer';

const Pass = {

  schema: {
    activated: { label: 'Activated', type: 'Boolean', defaultValue: true },
    filename: { label: 'Filename', type: 'Text', defaultValue: null },
    fileFormat: { label: 'File Format', type: 'Text', defaultValue: null },

    over_res: { label: 'On', type: 'Boolean', defaultValue: false },
    over_res_x: { label: 'Image Width', type: 'Number', defaultValue: 1280, isInteger: true },
    over_res_y: { label: 'Image Height', type: 'Number', defaultValue: 720, isInteger: true },

    render_cam: { type: 'Node', label: 'Camera', filter: targetCam },
    render_red: { type: 'Node', label: 'Renderer', filter: targetRen },
  },
};

export default { Pass };



// WEBPACK FOOTER //
// ./src/operators/Pass.js